import { Flex } from '@/hen-ui/composites/Flex';

import { CareerExplorerRecommendationDetailItem } from './CareerExplorerRecommendationDetailItem';
import type { CareerExplorerRecommendationDetail } from './types';

interface CareerExplorerRecommendationDetailsProps {
  details?: CareerExplorerRecommendationDetail[];
}

export const CareerExplorerRecommendationDetails = ({
  details = [],
}: CareerExplorerRecommendationDetailsProps) => {
  const visibleDetails = details.filter(
    (detail) => detail.label.trim().length > 0,
  );

  if (visibleDetails.length === 0) {
    return null;
  }

  const isFullRow = visibleDetails.length === 3;

  return (
    <Flex
      direction='row'
      gap='sm'
      align='center'
      justify={isFullRow ? 'between' : 'start'}
      wrap='wrap'
      width='full'
      data-slot='recommendation-details'
      className={isFullRow ? 'md:justify-start xl:justify-between' : ''}
    >
      {visibleDetails.map((detail) => (
        <CareerExplorerRecommendationDetailItem
          key={`${detail.icon}-${detail.label}`}
          {...detail}
        />
      ))}
    </Flex>
  );
};
